(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5033);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; },
  "getInitialAppParams": function() { return /* binding */ getInitialAppParams; },
  "getSimilarJobs": function() { return /* binding */ getSimilarJobs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/Search.tsx
var Search = __webpack_require__(4940);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/node_modules/axios/index.js
var axios = __webpack_require__(2063);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/utils/api/companySuggestions.js


/* eslint-disable camelcase */ 
/**
 * Request company suggestions from the service API.
 */ var fetchCompanySuggestionsPrivate = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(query, config) {
        var apiHost, _apiRequestTimeoutMs, apiRequestTimeoutMs, _appName, appName, queryObj, reqConfig, path, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiHost = config.apiHost, _apiRequestTimeoutMs = config.apiRequestTimeoutMs, apiRequestTimeoutMs = _apiRequestTimeoutMs === void 0 ? 5000 : _apiRequestTimeoutMs, _appName = config.appName, appName = _appName === void 0 ? "Design System" : _appName;
                    queryObj = query ? {
                        query: query
                    } : {};
                    reqConfig = {
                        params: Object.assign({
                            type: "company_name"
                        }, queryObj),
                        timeout: apiRequestTimeoutMs
                    };
                    path = "".concat(apiHost, "/api/v2/suggestions");
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return axios_default()(path, reqConfig);
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    console.error("Design System was unable to request company suggestions from ".concat(path), JSON.stringify(_ctx.t0));
                    return _ctx.abrupt("return", null);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    }));
    return function fetchCompanySuggestionsPrivate(query, config) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request company suggestions.
 */ var fetchCompanySuggestionsPublic = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inputValue, config) {
        var apiPath, _appName, appName, axiosOptions, path, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiPath = config.apiPath, _appName = config.appName, appName = _appName === void 0 ? "Design System" : _appName, axiosOptions = config.axiosOptions;
                    path = "".concat(apiPath, "/").concat(inputValue);
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return axios_default()(path, Object.assign({
                        timeout: 5000
                    }, axiosOptions));
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    console.error("".concat(appName, " was unable to request company suggestions from ").concat(path), JSON.stringify(_ctx.t0));
                    return _ctx.abrupt("return", null);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function fetchCompanySuggestionsPublic(inputValue, config) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Create mock API response.
 */ var mockCompanySuggestorResults = function(suggestions) {
    return suggestions.map(function(text) {
        return {
            object: "suggestion",
            type: "company_name",
            text: text,
            value: {
                object: "company_name_suggestion",
                short_name: text.toLowerCase().replace(/\s+/g, "_")
            },
            image: ""
        };
    });
};
 //# sourceMappingURL=companySuggestions.js.map

;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/hooks/useCompanySearch/useCompanySearch.tsx


/* eslint-disable camelcase */ 


var formatCompanySuggestions = function(companySuggestions) {
    return companySuggestions.slice(0, 4).map(function(companyResult) {
        var text = companyResult.text, value = companyResult.value;
        var short_name = value.short_name;
        return {
            label: "".concat(text),
            value: "/profiles/".concat(short_name)
        };
    });
};
var updateInput = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var changes, fetchConfig, setItems, inputValue, jobSearchItem, companyResults, companyList;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    changes = param.changes, fetchConfig = param.fetchConfig, setItems = param.setItems;
                    inputValue = changes.inputValue;
                    jobSearchItem = {
                        label: String(inputValue),
                        value: "/search/keyword/".concat(inputValue, "/")
                    };
                    if (!inputValue) {
                        _ctx.next = 12;
                        break;
                    }
                    setItems([
                        jobSearchItem
                    ]);
                    _ctx.next = 7;
                    return fetchCompanySuggestionsPublic(inputValue, fetchConfig);
                case 7:
                    companyResults = _ctx.sent;
                    companyList = (companyResults === null || companyResults === void 0 ? void 0 : companyResults.length) ? formatCompanySuggestions(companyResults) : [];
                    setItems([
                        jobSearchItem
                    ].concat(companyList));
                    _ctx.next = 13;
                    break;
                case 12:
                    {
                        setItems([]);
                    }
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateInput(_) {
        return _ref.apply(this, arguments);
    };
}();
var useCompanySearch = function(param) {
    var _debounceWait = param.debounceWait, debounceWait = _debounceWait === void 0 ? 10 : _debounceWait, fetchConfig = param.fetchConfig, icon = param.icon, _inputId = param.inputId, inputId = _inputId === void 0 ? "search-input" : _inputId, _onInputChange = param.onInputChange, onInputChange = _onInputChange === void 0 ? function() {} : _onInputChange;
    var ref = (0,react.useState)([]), dropdownItems = ref[0], setDropdownItems = ref[1];
    return {
        IconComponent: icon !== null && icon !== void 0 ? icon : Search/* default */.Z,
        debounceWait: debounceWait,
        dropdownList: dropdownItems,
        inputId: inputId,
        onInputChange: function(changes) {
            updateInput({
                changes: changes,
                fetchConfig: fetchConfig,
                setItems: setDropdownItems
            });
            onInputChange(changes);
        },
        noResultsMessage: " "
    };
};

// EXTERNAL MODULE: ./node_modules/@themuse/experiment-client/build/index.js
var build = __webpack_require__(6680);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(2708);
// EXTERNAL MODULE: ./src/utils/orm.ts + 2 modules
var orm = __webpack_require__(4416);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(9430);
// EXTERNAL MODULE: ./src/utils/api.ts + 1 modules
var api = __webpack_require__(2394);
// EXTERNAL MODULE: ./src/utils/ApplyButtonTextExperiment.ts
var ApplyButtonTextExperiment = __webpack_require__(2509);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 5 modules
var AppContext = __webpack_require__(6833);
// EXTERNAL MODULE: ./src/hooks/FeatureFlagsContext.tsx + 1 modules
var FeatureFlagsContext = __webpack_require__(65);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Pages/Layout.tsx + 33 modules
var Layout = __webpack_require__(8666);
;// CONCATENATED MODULE: ./src/components/JobIndividualPageLayout.tsx




/* eslint-disable camelcase */ 


var JobIndividualPageLayout = function(props) {
    var children = props.children, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    var user = (0,AppContext/* useAppState */.mr)().user;
    var pageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        user: user,
        staticMobileHeader: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: children
    }));
};


// EXTERNAL MODULE: ./src/components/JobIndividualHeader.tsx + 4 modules
var JobIndividualHeader = __webpack_require__(9969);
// EXTERNAL MODULE: ./src/components/JobIndividualBody.tsx + 12 modules
var JobIndividualBody = __webpack_require__(9116);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./src/utils/tracking.tsx
var tracking = __webpack_require__(1771);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./src/components/JobApplyButton.tsx + 2 modules
var JobApplyButton = __webpack_require__(5550);
// EXTERNAL MODULE: ./src/components/JobApplyButtonSideBarModule.module.scss
var JobApplyButtonSideBarModule_module = __webpack_require__(5810);
var JobApplyButtonSideBarModule_module_default = /*#__PURE__*/__webpack_require__.n(JobApplyButtonSideBarModule_module);
;// CONCATENATED MODULE: ./src/components/JobApplyButtonSideBarModule.tsx




var JobApplyButtonSideBarModule = function(props) {
    var jobState = props.jobState, jobId = props.jobId, trackJobApplyProps = props.trackJobApplyProps, setIsOpen = props.setIsOpen, isDirectApply = props.isDirectApply;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (JobApplyButtonSideBarModule_module_default()).jobApplyContainer,
        children: jobState === "live" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButton/* JobApplyButton */.q, {
            className: (JobApplyButtonSideBarModule_module_default()).applyButton,
            jobId: jobId,
            trackingProps: trackJobApplyProps,
            setIsOpen: setIsOpen,
            isDirectApply: isDirectApply
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (JobApplyButtonSideBarModule_module_default()).archived,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (JobApplyButtonSideBarModule_module_default()).archivedJobMessage,
                    children: "This job is no longer available."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                    href: "/search",
                    target: "_blank",
                    color: "mint",
                    children: "Search all jobs"
                })
            ]
        })
    });
};
JobApplyButtonSideBarModule.displayName = "JobApplyButtonSideBarModule";

// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var snowplow_js_client_build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
// EXTERNAL MODULE: ./src/components/JobIndividualSidebar.module.scss
var JobIndividualSidebar_module = __webpack_require__(5950);
var JobIndividualSidebar_module_default = /*#__PURE__*/__webpack_require__.n(JobIndividualSidebar_module);
;// CONCATENATED MODULE: ./src/components/SidebarJobTile.tsx

/* eslint-disable camelcase */ 



var SidebarJobTile = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var _$ref;
    var jobSearchData = props.jobSearchData, orderNum = props.orderNum;
    var title = jobSearchData.title, short_title = jobSearchData.short_title, company = jobSearchData.company, remote_work_location_type = jobSearchData.remote_work_location_type, locations = jobSearchData.locations;
    var location = remote_work_location_type === "virtual" ? "Remote" : (_$ref = locations[0]) === null || _$ref === void 0 ? void 0 : _$ref.address;
    var trackingProps = JSON.stringify({
        sp_impression_component: "tile",
        sp_impression_tile_type: "job",
        sp_impression_insert_type: null,
        sp_impression_modal_type: null,
        sp_impression_position: "right_rail",
        sp_tile_type: "job",
        sp_tile_entity_id: jobSearchData.legacy_id.toString(),
        sp_tile_entity_uuid: jobSearchData.id.toString(),
        sp_tile_order: orderNum,
        sp_tile_location: "similar_jobs",
        sp_tile_company_id: company === null || company === void 0 ? void 0 : company.legacy_id.toString(),
        sp_click_component: "tile",
        sp_click_component_tile_type: "job",
        sp_click_position: "right_rail",
        sp_click_target_page_section: "job_detail"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        ref: ref,
        "data-tracking-event-type": "impression",
        "data-tracking-props": trackingProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (JobIndividualSidebar_module_default()).jobTileLink,
                href: "/jobs/".concat(company === null || company === void 0 ? void 0 : company.short_name, "/").concat(short_title),
                target: "_blank",
                onClick: function() {
                    return (0,snowplow_js_client_build.triggerSnowplowClickEvent)(JSON.parse(trackingProps));
                },
                children: (0,strings/* truncateStringWithEllipsis */.a1)(title, 75)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: (0,strings/* truncateStringWithEllipsis */.a1)(company === null || company === void 0 ? void 0 : company.name, 25)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: location
            })
        ]
    });
});
SidebarJobTile.displayName = "SidebarJobTile";

;// CONCATENATED MODULE: ./src/components/SimilarJobsSidebar.tsx







var SimilarJobsSidebar = function() {
    var ref, ref1;
    var ref2 = (0,AppContext/* useAppState */.mr)(), job = ref2.job, similarJobs = ref2.similarJobs;
    // We only ever want a max of three jobs, and we don't want to include the job we are displaying, so we request 4 and filter it out
    var tiles = similarJobs === null || similarJobs === void 0 ? void 0 : (ref = similarJobs.hits) === null || ref === void 0 ? void 0 : ref.filter(function(searchHit) {
        return searchHit.hit.legacy_id !== job.id;
    }).slice(0, 3).map(function(searchHit, index) {
        var hit = searchHit.hit;
        var company = hit.company;
        var trackingProps = (0,_object_spread/* default */.Z)({}, (0,tracking/* getJobTrackingProps */.C)(hit, company), {
            placement_position: "job detail page",
            placement: "Individual Job",
            order_num: index + 1,
            recommended: true
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarJobTile, {
            jobSearchData: hit,
            orderNum: index + 1,
            "data-tracking-event-type": "impression",
            "data-tracking-props": JSON.stringify(trackingProps)
        }, hit.id);
    });
    return (similarJobs === null || similarJobs === void 0 ? void 0 : (ref1 = similarJobs.hits) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualSidebar_module_default()).similarJobsModule,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Similar Jobs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: tiles
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./src/components/SuggestedSearchesSidebarModule.tsx




var SuggestedSearchesSidebarModule = function(props) {
    var ref, ref1, ref2;
    var job = props.job, company = props.company, museWebHost = props.museWebHost;
    var suggestedSearchLinks = [
        {
            suggestedSearchType: "level",
            href: "".concat(museWebHost, "/search/level/").concat((ref = job === null || job === void 0 ? void 0 : job.levels[0]) === null || ref === void 0 ? void 0 : ref.value),
            displayText: "".concat((ref1 = job === null || job === void 0 ? void 0 : job.levels[0]) === null || ref1 === void 0 ? void 0 : ref1.display, " jobs"),
            active: !!(job === null || job === void 0 ? void 0 : (ref2 = job.levels) === null || ref2 === void 0 ? void 0 : ref2.length)
        },
        {
            suggestedSearchType: "company",
            href: "".concat(museWebHost, "/hiring/company/").concat(company === null || company === void 0 ? void 0 : company.short_name),
            displayText: "".concat(company === null || company === void 0 ? void 0 : company.name, " jobs"),
            active: true
        },
        {
            suggestedSearchType: "alljobs",
            href: "".concat(museWebHost, "/hiring"),
            displayText: "All jobs",
            active: true
        }, 
    ];
    var category = job === null || job === void 0 ? void 0 : job.categories[0];
    if ((category === null || category === void 0 ? void 0 : category.value.toLowerCase()) !== "unknown") {
        var ref3;
        suggestedSearchLinks = [
            {
                suggestedSearchType: "category",
                href: "".concat(museWebHost, "/hiring/category/").concat(category === null || category === void 0 ? void 0 : category.code),
                displayText: "".concat(category === null || category === void 0 ? void 0 : category.value, " jobs"),
                active: !!(job === null || job === void 0 ? void 0 : (ref3 = job.categories) === null || ref3 === void 0 ? void 0 : ref3.length)
            }
        ].concat((0,_to_consumable_array/* default */.Z)(suggestedSearchLinks));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualSidebar_module_default()).suggestedSearchesModule,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Suggested Searches"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: suggestedSearchLinks.map(function(searchLink, index) {
                    return searchLink.active ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: searchLink.href,
                            children: searchLink.displayText
                        })
                    }, "suggested-search-link-".concat(searchLink.suggestedSearchType)) : null;
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/location.ts
var utils_location = __webpack_require__(4345);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowUpShape.tsx
var ArrowUpShape = __webpack_require__(2965);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowDownShape.tsx
var ArrowDownShape = __webpack_require__(8053);
// EXTERNAL MODULE: ./src/components/AdditionalJobLinkList.module.scss
var AdditionalJobLinkList_module = __webpack_require__(9039);
var AdditionalJobLinkList_module_default = /*#__PURE__*/__webpack_require__.n(AdditionalJobLinkList_module);
;// CONCATENATED MODULE: ./src/components/AdditionalJobLinkList.tsx







var AdditionalJobLinkList = function() {
    var ref = (0,react.useState)(false), viewAll = ref[0], setViewAll = ref[1];
    var ref1 = (0,react.useState)(false), isMobileScreen = ref1[0], setIsMobileScreen = ref1[1];
    var job = (0,AppContext/* useAppState */.mr)().job;
    var _locations = job.locations, locations = _locations === void 0 ? [] : _locations, _categories = job.categories, categories = _categories === void 0 ? [] : _categories, normalizedTitle = job.normalizedTitle;
    var handleWindowResize = (0,react.useCallback)(function() {
        setIsMobileScreen(window.innerWidth < 768);
    }, []);
    (0,react.useEffect)(function() {
        var mobile = window.matchMedia("(max-width:768px)");
        mobile.addEventListener("resize", handleWindowResize);
        return function() {
            mobile.removeEventListener("change", handleWindowResize);
        };
    }, [
        handleWindowResize
    ]);
    var showViewMore = (0,react.useCallback)(function() {
        var totalResults = locations.length * 3;
        switch(true){
            case isMobileScreen && totalResults > 10:
            case !isMobileScreen && totalResults > 8:
                return true;
            default:
                return false;
        }
    }, [
        isMobileScreen,
        locations.length
    ]);
    if (!(locations === null || locations === void 0 ? void 0 : locations.length)) return null;
    var viewAllOnClick = function() {
        setViewAll(!viewAll);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-labelledby": "additionalJobLinkList",
        className: "".concat((AdditionalJobLinkList_module_default()).additionalJobLinkList),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "additionalJobLinkList",
                className: "".concat((AdditionalJobLinkList_module_default()).linkHeader),
                children: "Search Additional Jobs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((AdditionalJobLinkList_module_default()).linkListContainer, " ").concat(viewAll ? (AdditionalJobLinkList_module_default()).fullList : (AdditionalJobLinkList_module_default()).limitedList),
                children: [
                    normalizedTitle && locations.filter(function(x) {
                        return x === null || x === void 0 ? void 0 : x.value;
                    }).map(function(location) {
                        var isRemote = (0,utils_location/* locationIsRemote */.D)(location);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "".concat((AdditionalJobLinkList_module_default()).singleJobLink),
                            "data-linktype": "keywordAndLocation",
                            "data-pos": "bottom_search_additional_jobs",
                            href: "/hiring/location/".concat((0,strings/* slugifyLocation */.WH)(location.value), "/keyword/").concat((0,strings/* slugify */.lV)(normalizedTitle), "/"),
                            target: "_blank",
                            "aria-label": isRemote ? "Search Remote-friendly ".concat(normalizedTitle, " Jobs") : "Search ".concat(normalizedTitle, " Jobs in ").concat(location.value),
                            children: isRemote ? "Remote-friendly ".concat(normalizedTitle, " Jobs") : "".concat(normalizedTitle, " Jobs in ").concat(location.value)
                        }, location.id);
                    }),
                    locations.filter(function(x) {
                        return x.value;
                    }).map(function(location) {
                        var slugifiedValue = (0,strings/* slugifyLocation */.WH)(location.value);
                        var isRemote = (0,utils_location/* locationIsRemote */.D)(location);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "".concat((AdditionalJobLinkList_module_default()).singleJobLink),
                            "data-linktype": "location",
                            "data-pos": "bottom_search_addtional_jobs",
                            href: "/hiring/location/".concat(slugifiedValue, "/"),
                            target: "_blank",
                            "aria-label": isRemote ? "Search Remote-friendly Jobs" : "Search Jobs in ".concat(location.value),
                            children: isRemote ? "Remote-friendly Jobs" : "Jobs in ".concat(location.value)
                        }, location.id);
                    }),
                    categories.length > 0 && locations.map(function(location) {
                        var category = categories[0].value;
                        var categoryLink = categories[0].code;
                        var slugifiedLocation = (0,strings/* slugifyLocation */.WH)(location.value);
                        var isRemote = (0,utils_location/* locationIsRemote */.D)(location);
                        if (category.toLocaleLowerCase() === "unknown") return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "".concat((AdditionalJobLinkList_module_default()).singleJobLink),
                            href: "/hiring/location/".concat(slugifiedLocation, "/category/").concat(categoryLink, "/"),
                            target: "_blank",
                            "data-linktype": "categoryAndLocation",
                            "data-pos": "bottom_search_addtional_jobs",
                            "aria-label": isRemote ? "Search ".concat(category, " Remote-friendly Jobs") : "Search ".concat(category, " Jobs in ").concat(location.value),
                            children: isRemote ? "".concat(category, " Remote-friendly Jobs") : "".concat(category, " Jobs in ").concat(location.value)
                        }, location.id);
                    })
                ]
            }),
            showViewMore() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((AdditionalJobLinkList_module_default()).gradientOverlay, " ").concat(viewAll ? (AdditionalJobLinkList_module_default()).noGradient : "", " viewMoreSection"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (AdditionalJobLinkList_module_default()).viewAllContentContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AdditionalJobLinkList_module_default()).viewAllSeparatorLine
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: viewAllOnClick,
                            type: "button",
                            "data-viewbutton": "viewbutton",
                            className: "".concat((AdditionalJobLinkList_module_default()).viewMoreButton, " ").concat(viewAll ? (AdditionalJobLinkList_module_default()).arrowUpAlignment : ""),
                            children: [
                                viewAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpShape/* default */.Z, {
                                    title: "ArrowUpShape",
                                    titleId: "ArrowUpShape",
                                    className: (AdditionalJobLinkList_module_default()).arrowStyling
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownShape/* default */.Z, {
                                    title: "ArrowDownShape",
                                    titleId: "ArrowDownShape",
                                    className: (AdditionalJobLinkList_module_default()).arrowStyling
                                }),
                                viewAll ? "VIEW LESS" : "VIEW MORE"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AdditionalJobLinkList_module_default()).viewAllSeparatorLine
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/JobIndividualSidebar.tsx




/* eslint-disable camelcase */ 











var JobIndividualSidebar = function(props) {
    var setIsOpen = props.setIsOpen;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState("right_rail"), 2), buttonPlacement = ref[0], setButtonPlacement = ref[1];
    var ref1 = (0,AppContext/* useAppState */.mr)(), job = ref1.job, company = ref1.company;
    var state = job.state, _ats_info = job.ats_info, ats_info = _ats_info === void 0 ? {
        directApplyService: ""
    } : _ats_info;
    var directApplyService = ats_info.directApplyService;
    var ref2 = (0,config["default"])(), museWebHost = ref2.publicRuntimeConfig.museWebHost;
    var jobTrackingProps = (0,tracking/* getJobTrackingProps */.C)(job, company);
    var experiments = (0,build.useExperimentState)().experiments;
    var buttonText = (0,react.useMemo)(function() {
        return (0,ApplyButtonTextExperiment/* getApplyButtonText */.p)(state, directApplyService, experiments, build.getActiveVariant);
    }, [
        state,
        directApplyService,
        experiments
    ]);
    var liveTargetSection = directApplyService ? "direct_apply_form" : "off_site";
    var targetSection = state === "live" ? liveTargetSection : "search";
    var isLive = state === "live";
    var trackingObj = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jobTrackingProps), {
        sp_click_button_text: buttonText,
        sp_click_target_page_section: targetSection,
        sp_click_position: buttonPlacement,
        target_page_section: "direct_apply_form",
        sp_click_button_type: isLive ? "apply" : "job_search"
    });
    (0,react.useEffect)(function() {
        if ((0,browser/* isMobile */.tq)()) {
            setButtonPlacement("bottom");
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                className: (JobIndividualSidebar_module_default()).jobSidebarContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButtonSideBarModule, {
                        jobState: job.state,
                        jobId: job.id,
                        trackJobApplyProps: trackingObj,
                        setIsOpen: setIsOpen,
                        isDirectApply: !!directApplyService
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (JobIndividualSidebar_module_default()).sidebarModules,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarJobsSidebar, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedSearchesSidebarModule, {
                                job: job,
                                company: company,
                                museWebHost: museWebHost
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalJobLinkList, {})
        ]
    });
};
JobIndividualSidebar.displayName = "JobIndividualSidebar";

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/JobPostJsonLd.tsx




/* eslint-disable @next/next/no-before-interactive-script-outside-document */ /* eslint-disable camelcase */ /* eslint-disable react/no-danger */ 





/**
 * Construct a job url.
 */ var getJobUrl = function(companyShortName, jobShortname) {
    var ref = (0,config["default"])(), appEnv = ref.publicRuntimeConfig.appEnv;
    var path = "/jobs/".concat(companyShortName, "/").concat(jobShortname);
    return appEnv === "production" ? "https://www.themuse.com".concat(path) : "https://www.staging-themuse.com".concat(path);
};
/**
 * Retrieve the parts of the location from the geocoded properties of an address_components
 */ var getParts = function(item) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (item === null || item === void 0 ? void 0 : (ref = item.types) === null || ref === void 0 ? void 0 : ref.includes("street_number")) return {
        streetAddress: item.long_name
    };
    if (item === null || item === void 0 ? void 0 : (ref1 = item.types) === null || ref1 === void 0 ? void 0 : ref1.includes("route")) return {
        route: item.long_name
    };
    if (item === null || item === void 0 ? void 0 : (ref2 = item.types) === null || ref2 === void 0 ? void 0 : ref2.includes("locality")) return {
        addressLocality: item.long_name
    };
    if (item === null || item === void 0 ? void 0 : (ref3 = item.types) === null || ref3 === void 0 ? void 0 : ref3.includes("postal_code")) return {
        postalCode: item.short_name
    };
    if (item === null || item === void 0 ? void 0 : (ref4 = item.types) === null || ref4 === void 0 ? void 0 : ref4.includes("administrative_area_level_1")) return {
        addressRegion: item.short_name
    };
    if (item === null || item === void 0 ? void 0 : (ref5 = item.types) === null || ref5 === void 0 ? void 0 : ref5.includes("country")) return {
        addressCountry: item.short_name
    };
    return {};
};
/**
 * Generates the JSON address object with whatever keys we can find.
 * Yes, it is a huge complexity number but breaking it up might seem more confusing.
 */ var getJSONFromGeocodedLocation = function(location) {
    var geocodedLocations = Array.isArray(location === null || location === void 0 ? void 0 : location.geocoded_locations) ? location.geocoded_locations : [
        location === null || location === void 0 ? void 0 : location.geocoded_locations
    ];
    var stringifiedGeo = geocodedLocations === null || geocodedLocations === void 0 ? void 0 : geocodedLocations.map(function(geo) {
        var ref, ref1;
        // Now we loop again over the addresses
        var result = (ref1 = geo === null || geo === void 0 ? void 0 : (ref = geo.address_components) === null || ref === void 0 ? void 0 : ref.map(getParts)) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(a, b) {
            return (0,_object_spread/* default */.Z)({}, a, b);
        }, {});
        // Append the json type.
        if (result) {
            result["@type"] = "PostalAddress";
            // Combine the street address and route into a full local address.
            if ((result === null || result === void 0 ? void 0 : result.streetAddress) && (result === null || result === void 0 ? void 0 : result.route)) {
                result.streetAddress = "".concat(result.streetAddress, " ").concat(result.route);
                delete result.route;
            }
            // Remove all the empty/falsy properties.
            Object.keys(result).forEach(function(key) {
                if (!result[key]) {
                    delete result[key];
                }
            });
        }
        return result ? {
            "@type": "Place",
            address: result
        } : {};
    })// Reduce to a single array.
    .flat()// Remove empty objects or ones that only have the @type.
    .filter(function(x) {
        return Object.keys(x).length > 1;
    })// Remove null and undefined entries
    .filter(Boolean).map(function(x) {
        return JSON.stringify(x);
    });
    return (stringifiedGeo === null || stringifiedGeo === void 0 ? void 0 : stringifiedGeo.length) ? (0,_to_consumable_array/* default */.Z)(new Set(stringifiedGeo)).map(function(x) {
        return JSON.parse(x);
    }) : [];
};
/**
 * Generate a JSON address format for locations.
 */ var getMuseLocations = function(locations) {
    return locations.filter(function(location) {
        return !(0,utils_location/* locationIsRemote */.D)(location);
    }).map(function(location) {
        return {
            "@type": "Place",
            address: {
                "@type": "PostalAddress",
                addressLocality: location === null || location === void 0 ? void 0 : location.city,
                addressCountry: location === null || location === void 0 ? void 0 : location.country,
                addressRegion: location === null || location === void 0 ? void 0 : location.state
            }
        };
    });
};
/**
 * Filter for actual locations and format them for consumption by google.
 */ var getJobLocations = function(locations) {
    var geoCodedLocations = locations.filter(function(location) {
        return !(0,utils_location/* locationIsRemote */.D)(location);
    }).map(getJSONFromGeocodedLocation).flat();
    return geoCodedLocations.length < 1 ? getMuseLocations(locations) : geoCodedLocations;
};
/**
 * Convert the perks and benefits object into a single comma delimited string of perk names.
 */ var getBenefitsString = function(perkList) {
    return Object.keys(perkList).map(function(group) {
        return perkList[group].perks.map(function(perk) {
            return perk.name;
        }).filter(Boolean).join(",");
    }).filter(Boolean).join(", ");
};
/**
 * Generates a JSON-LD object for a job posting by extracting relevant properties from the company and job objects..
 */ var generateJobPostingJson = function(props) {
    var company = props.company, job = props.job;
    var perks_and_benefits = company.perks_and_benefits, companyName = company.name, logo = company.logo, companyShortName = company.short_name;
    var _locations = job.locations, locations = _locations === void 0 ? [] : _locations, datePosted = job.posted_at, _compiled_contents = job.compiled_contents, compiled_contents = _compiled_contents === void 0 ? [] : _compiled_contents, title = job.name, validThrough = job.valid_through, jobShortName = job.short_name, ats_info = job.ats_info;
    var jobLocation = getJobLocations(locations);
    var isFlexibleRemote = locations.some(function(location) {
        return (0,utils_location/* locationIsRemote */.D)(location);
    });
    var jobBenefits = getBenefitsString(perks_and_benefits);
    try {
        var jsonld = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "@context": "https://schema.org",
            "@type": "JobPosting",
            datePosted: datePosted,
            description: compiled_contents.join(""),
            experienceRequirements: "no requirements",
            hiringOrganization: {
                "@type": "Organization",
                name: companyName,
                logo: (0,strings/* getCompanyLogo */.GW)(logo)
            }
        }, jobLocation.length && {
            jobLocation: jobLocation
        }, isFlexibleRemote && {
            jobLocationType: "TELECOMMUTE",
            applicantLocationRequirements: {
                "@type": "Country",
                sameAs: "https://www.wikidata.org/wiki/Q30",
                name: "USA"
            }
        }), {
            title: title,
            employmentType: job.employmentTypes,
            url: getJobUrl(companyShortName, jobShortName)
        }), validThrough && {
            validThrough: validThrough
        }), {
            identifier: {
                "@type": "PropertyValue",
                name: companyName,
                value: ats_info === null || ats_info === void 0 ? void 0 : ats_info.id
            }
        }), jobBenefits && {
            jobBenefits: jobBenefits
        });
        return jsonld;
    } catch (error) {
        var msg = "Error constructing the LD+JSON for ".concat(companyShortName, "\\").concat(jobShortName);
        var err = JSON.stringify((0,logging/* formatLog */.Uo)({
            error: error
        }));
        console.error(msg, err);
    }
    return {};
};
/**
 * Generates JSON-LD structured data for a job posting.
 */ var JobPostJsonLd = function() {
    var ref = (0,AppContext/* useAppState */.mr)(), company = ref.company, job = ref.job;
    var _locations = job.locations, locations = _locations === void 0 ? [] : _locations, _state = job.state, state = _state === void 0 ? "" : _state;
    var tmp = company["package"], pkg = tmp === void 0 ? "" : tmp;
    var jobLocation = getJobLocations(locations);
    var isFlexibleRemote = locations.some(function(location) {
        return (0,utils_location/* locationIsRemote */.D)(location);
    });
    var hasValidLocation = isFlexibleRemote || jobLocation.length;
    // Ruleset for suppressing the job post JSONLd.
    var IsSuppressed = [
        !hasValidLocation,
        state !== "live",
        pkg === "Programmatic"
    ].some(Boolean);
    if (IsSuppressed) return null;
    var jsonld = generateJobPostingJson({
        company: company,
        job: job
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        strategy: "beforeInteractive",
        id: "JobPost-JSON",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(jsonld)
        }
    }, "JobPost-JSON");
};
// WARNING: This is for unit testing only and should NEVER be used directly outside this file.
var generateJobPostingJsonTestingOnly = (/* unused pure expression or super */ null && (generateJobPostingJson));


// EXTERNAL MODULE: ./src/components/UserInit.tsx
var UserInit = __webpack_require__(2262);
// EXTERNAL MODULE: ./src/components/StickyHeader.tsx
var StickyHeader = __webpack_require__(6472);
// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./src/pages/index.tsx






/* eslint-disable camelcase */ /** 3rd party */ 


/** 3rd party @themuse */ 






/** hooks */ 

/** components */ 






/** styles */ 
var __N_SSP = true;
/**
 * Retrieve a list of similar jobs based on the input job.
 */ var getSimilarJobs = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(job) {
        var ref, ref1, _name, name, _levels, levels, ref2, ref3, similarJobsRequest, similarJobs, ref4, msg, e;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ref1 = job || {}, _name = ref1.name, name = _name === void 0 ? "" : _name, _levels = ref1.levels, levels = _levels === void 0 ? [] : _levels;
                    ;
                    similarJobsRequest = {
                        query: (ref2 = name === null || name === void 0 ? void 0 : name.split(" ").slice(0, 3).join(" ")) !== null && ref2 !== void 0 ? ref2 : "",
                        level: (ref3 = (ref = levels === null || levels === void 0 ? void 0 : levels.map(function(level) {
                            return (level === null || level === void 0 ? void 0 : level.value) === "senior" ? "senior,management" : level === null || level === void 0 ? void 0 : level.value;
                        })) === null || ref === void 0 ? void 0 : ref.join(",")) !== null && ref3 !== void 0 ? ref3 : null,
                        limit: 4
                    };
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return (0,api/* searchJobs */.B5)(similarJobsRequest);
                case 7:
                    similarJobs = _ctx.sent;
                    return _ctx.abrupt("return", similarJobs);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    ;
                    msg = "Error requesting similar jobs for job '".concat(name, "' at ").concat(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.request) === null || ref4 === void 0 ? void 0 : ref4.path, ".");
                    e = (0,logging/* wrapError */.Jn)(msg, _ctx.t0);
                    logging/* logger.log */.kg.log((0,logging/* formatLog */.Uo)({
                        error: e,
                        level: "warn"
                    }));
                case 17:
                    return _ctx.abrupt("return", null);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    }));
    return function getSimilarJobs(job) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Experiment configurations.
 */ var experimentConfig = ApplyButtonTextExperiment/* applyButtonTextConfig */.M;
/**
 * Checks if a job is archived.
 */ var checkArchived = function(job) {
    return (job === null || job === void 0 ? void 0 : job.state) === "archived";
};
/**
 * Retrieves initial application parameters including experiments, variant, job, company, similar jobs, and archived.
 */ var getInitialAppParams = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(context) {
        var ref, ref1, activeExperiments, ref2, experiments, ref3, job, company, ref4, directApplyService, archived, similarJobs, experimentId, ref5, enabledVariant;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ref1 = (0,config["default"])(), activeExperiments = ref1.publicRuntimeConfig.activeExperiments;
                    ;
                    experiments = (ref2 = (0,build.getExperiments)(experimentConfig, context, activeExperiments)) !== null && ref2 !== void 0 ? ref2 : [];
                    _ctx.next = 6;
                    return (0,orm/* getCompressedJob */.D)(context);
                case 6:
                    ref3 = _ctx.sent;
                    job = ref3.job;
                    company = ref3.company;
                    ;
                    directApplyService = (ref4 = job === null || job === void 0 ? void 0 : (ref = job.ats_info) === null || ref === void 0 ? void 0 : ref.directApplyService) !== null && ref4 !== void 0 ? ref4 : "";
                    archived = checkArchived(job);
                    _ctx.next = 14;
                    return getSimilarJobs(job);
                case 14:
                    similarJobs = _ctx.sent;
                    experimentId = directApplyService ? "DIRECT_APPLY_CTA_COPY" : "APPLY_CTA_COPY";
                    ;
                    enabledVariant = (ref5 = (0,build.getActiveVariant)(experimentId, experiments)) !== null && ref5 !== void 0 ? ref5 : "";
                    return _ctx.abrupt("return", {
                        job: job,
                        company: company,
                        similarJobs: similarJobs,
                        experiments: experiments,
                        enabledVariant: enabledVariant,
                        archived: archived,
                        isJob: true,
                        isFramed: false
                    });
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getInitialAppParams(context) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Compiles the props object for the page layout component.
 */ var getPageLayoutProps = function(companySearchDropdownProps) {
    return {
        activePath: "/search",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        enableCompanySearch: true,
        companySearchDropdownProps: companySearchDropdownProps,
        searchUrl: "/search",
        showSubMenus: true,
        handleModalFormSubmit: api/* newsletterSubscribeRequest */.Pl
    };
};
/**
 * Config for triggering inView value for the sticky nav.
 */ var inViewConfig = {
    triggerOnce: false,
    root: null,
    rootMargin: "0px",
    threshold: 0.9
};
/**
 * Retrieves server-side props for the page, including experiments, job and company details, similar jobs, and feature flags.
 * Handles cases of archived jobs, not found pages, and redirects based on initial app parameters.
 * Returns an object with notFound status, redirect configuration, and props containing necessary data for the page.
 */ var Home = function(props) {
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isSticky = ref2[0], setIsSticky = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isDirectApplyOpen = ref3[0], setIsDirectApplyOpen = ref3[1];
    var ref4 = (0,config["default"])(), _publicRuntimeConfig = ref4.publicRuntimeConfig, museWebHost = _publicRuntimeConfig.museWebHost, apiBase = _publicRuntimeConfig.apiBase;
    var ref5 = (0,react_intersection_observer/* useInView */.YD)(inViewConfig), ref6 = ref5.ref, inView = ref5.inView;
    var initialAppParams = props.initialAppParams, featureFlags = props.featureFlags, experiments = props.experiments;
    var companySearchDropdownProps = useCompanySearch({
        fetchConfig: {
            apiPath: "".concat(apiBase, "company-suggestion")
        }
    });
    var job = initialAppParams.job, company = initialAppParams.company;
    var ats_info = job.ats_info, id = job.id, _locations = job.locations, locations = _locations === void 0 ? [] : _locations, _apply_link = job.apply_link, apply_link = _apply_link === void 0 ? "" : _apply_link, _categories = job.categories, categories = _categories === void 0 ? [] : _categories, _levels = job.levels, levels = _levels === void 0 ? [] : _levels, _state = job.state, state = _state === void 0 ? "" : _state, tmp = job.name, jobName = tmp === void 0 ? "" : tmp, _normalizedTitle = job.normalizedTitle, normalizedTitle = _normalizedTitle === void 0 ? "" : _normalizedTitle, tmp1 = job.short_name, jobShortName = tmp1 === void 0 ? "" : tmp1;
    var tmp2 = company.name, companyName = tmp2 === void 0 ? "" : tmp2, tmp3 = company.short_name, companyShortName = tmp3 === void 0 ? "" : tmp3, _legacy_id = company.legacy_id, legacy_id = _legacy_id === void 0 ? "" : _legacy_id;
    var ref7 = ats_info || {}, _directApplyPath = ref7.directApplyPath, directApplyPath = _directApplyPath === void 0 ? "" : _directApplyPath, _directApplyService = ref7.directApplyService, directApplyService = _directApplyService === void 0 ? "" : _directApplyService;
    var physicalLocations = locations.filter(function(location) {
        return (location === null || location === void 0 ? void 0 : location.value) !== "Flexible / Remote";
    });
    var ref8;
    var firstLocation = (ref8 = physicalLocations === null || physicalLocations === void 0 ? void 0 : (ref = physicalLocations[0]) === null || ref === void 0 ? void 0 : ref.value) !== null && ref8 !== void 0 ? ref8 : "";
    var firstlocationDisplay = firstLocation ? " located in ".concat(firstLocation, ", ") : ", ";
    var canonical = "".concat(museWebHost, "/jobs/").concat(companyShortName, "/").concat(jobShortName);
    var descriptionEnd = "as well as other career opportunities that the company is hiring for.";
    var description = "Find our ".concat(jobName, " job description for ").concat(companyName).concat(firstlocationDisplay, " ").concat(descriptionEnd);
    var noIndex = state !== "live";
    var title = "".concat(jobName, " at ").concat(companyName, " | The Muse");
    var setIsOpen = directApplyService ? setIsDirectApplyOpen : null;
    var pageLayoutProps = getPageLayoutProps(companySearchDropdownProps);
    var ref9, ref10;
    var directApplyProps = {
        companyId: legacy_id + "",
        companyName: companyName,
        endpoint: directApplyPath,
        jobId: id,
        jobCategory: categories === null || categories === void 0 ? void 0 : categories[0],
        normalizedTitle: normalizedTitle,
        level: (ref9 = levels === null || levels === void 0 ? void 0 : (ref1 = levels[0]) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref9 !== void 0 ? ref9 : "",
        jobName: jobName,
        link: apply_link,
        locations: locations,
        atsJobId: (ref10 = ats_info === null || ats_info === void 0 ? void 0 : ats_info.id) !== null && ref10 !== void 0 ? ref10 : "",
        service: directApplyService
    };
    (0,react.useEffect)(function() {
        setIsSticky(!inView);
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext/* FeatureFlagsProvider */.O, {
        featureFlags: featureFlags,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppContext/* AppProvider */.wI, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialAppParams), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: title,
                    description: description,
                    canonical: canonical,
                    openGraph: {
                        url: canonical,
                        title: title,
                        description: description
                    },
                    noindex: noIndex
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostJsonLd, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInit/* UserInit */.E, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobIndividualPageLayout, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageLayoutProps), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(build.ExperimentProvider, {
                            experiments: experiments,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyHeader/* StickyHeader */.M, {
                                    setIsOpen: setIsOpen,
                                    isSticky: isSticky
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(JobIndividualHeader/* JobIndividualHeader */.Op, {
                                    innerRef: ref6,
                                    setIsOpen: setIsOpen
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(JobIndividualBody/* JobIndividualBody */.R, {
                                    setIsOpen: setIsOpen
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(JobIndividualSidebar, {
                                    setIsOpen: setIsOpen
                                })
                            ]
                        })
                    }))
                })
            ]
        }))
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 9039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalJobLinkList":"AdditionalJobLinkList_additionalJobLinkList__a2hQn","linkHeader":"AdditionalJobLinkList_linkHeader__HTLuf","linkListContainer":"AdditionalJobLinkList_linkListContainer__LO4gs","limitedList":"AdditionalJobLinkList_limitedList__HtEEM","fullList":"AdditionalJobLinkList_fullList__wxda2","singleJobLink":"AdditionalJobLinkList_singleJobLink__IRztK","gradientOverlay":"AdditionalJobLinkList_gradientOverlay__HH3H_","noGradient":"AdditionalJobLinkList_noGradient__rAzRp","viewAllContentContainer":"AdditionalJobLinkList_viewAllContentContainer__Y6uUt","viewAllSeparatorLine":"AdditionalJobLinkList_viewAllSeparatorLine__9CAOI","viewMoreButton":"AdditionalJobLinkList_viewMoreButton__nRygu","arrowUpAlignment":"AdditionalJobLinkList_arrowUpAlignment__rLbfG","arrowStyling":"AdditionalJobLinkList_arrowStyling__lG1JH"};

/***/ }),

/***/ 5810:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applyButton":"JobApplyButtonSideBarModule_applyButton__h7WCR","jobApplyContainer":"JobApplyButtonSideBarModule_jobApplyContainer__Hlere","archivedJobMessage":"JobApplyButtonSideBarModule_archivedJobMessage__nS3YO","pulse":"JobApplyButtonSideBarModule_pulse__BMnjY","archived":"JobApplyButtonSideBarModule_archived__pvdM2","gradient":"JobApplyButtonSideBarModule_gradient__05jsH"};

/***/ }),

/***/ 5950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobSidebarContainer":"JobIndividualSidebar_jobSidebarContainer__eX5_t","sidebarModules":"JobIndividualSidebar_sidebarModules__elgun","similarJobsModule":"JobIndividualSidebar_similarJobsModule__QDX2z","suggestedSearchesModule":"JobIndividualSidebar_suggestedSearchesModule__snmNH"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseGrid":"Home_baseGrid__5iHw2","main":"Home_main__zgAJj Home_baseGrid__5iHw2","pageHeader":"Home_pageHeader__Y8w6l"};

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [64,94,639,25,949,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);